import React, { useContext, useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { ProfileContext } from '../../../contexts/ProfileContext';
import { RegionPaysLoire, SSMFLogo, WksMFLogo } from '../../../assets/logos';
import LanguageDropdown from '../../common/LanguageDropdown';
import Button from '../../ui/button';
import Popups from '../../popups';
import { getTranslation } from '../../../utils';

export default function StaticHeader({ forceRegionPaysLoire = false }) {
  const { i18n, t } = useTranslation();
  const navigate = useNavigate();
  const [langOptions, setLangOptions] = useState([]);
  const [showLogoutPopup, setShowLogoutPopup] = useState(false);
  const [isLoggingOut, setIsLoggingOut] = useState(false);

  const [profile] = useContext(ProfileContext);

  const {
    profileTypeData: { _id: profileTypeId } = {},
    masterOrganization = {},
    masterData: { languages: _languagesOptions = [], translationPrefix } = {}
  } = profile;

  useEffect(() => {
    if (_languagesOptions.length === 0) return;
    const langOptions = _languagesOptions.map((lang) => {
      return { label: lang?.toUpperCase(), value: lang };
    });
    setLangOptions(langOptions);
  }, [_languagesOptions]);

  const handleChangeLanguage = (lang) => {
    i18n.changeLanguage(lang.value);
    localStorage.setItem('lang', lang.value);
  };

  const handleLogoutConfirm = async () => {
    setIsLoggingOut(true);

    try {
      // Clear token from localStorage
      try {
        localStorage.removeItem('token');
      } catch (error) {
        console.log('LS Unavailable');
      }

      // Navigate to login page
      navigate('/');
    } catch (error) {
      console.error('Logout error:', error);
      setIsLoggingOut(false);
    } finally {
      setIsLoggingOut(false);
    }
  };

  const isRegionPaysLoire = forceRegionPaysLoire || profileTypeId === '689da0000864d908a98c655c';

  const isWSF = masterOrganization === '650bd89479ba3ae92524955b';
  const isSSK = masterOrganization === '650bd7c379ba3ae92524955a';

  return (
    <div
      className={`fixed top-0 left-0 w-full z-50 px-10 py-6 border-b border-gray-300 shadow-sm ${
        isSSK ? 'bg-chred-500' : 'bg-white'
      }`}>
      <div
        className={`flex items-center gap-6 max-w-5xl mx-auto ${
          !isRegionPaysLoire && !isSSK ? 'justify-center' : isSSK ? 'justify-between' : ''
        }`}>
        {isRegionPaysLoire && (
          <div className="h-16 flex items-center">
            <RegionPaysLoire color="#163F9B" className="h-full" />
          </div>
        )}
        {isRegionPaysLoire && (
          <img
            src="/images/region_rbbe_logo.png"
            alt="Region Big Bang Emploi Logo"
            className="h-16 object-contain"
          />
        )}
        <div className="h-16 flex items-center">
          {(forceRegionPaysLoire || isWSF) && <WksMFLogo color="#163F9B" className="h-full" />}
          {isSSK && <SSMFLogo color="#E60000" className="h-full" />}
        </div>
        <div className="flex-1" />
        <div className="flex items-baseline gap-4 ">
          {langOptions.length > 1 && (
            <LanguageDropdown
              value={langOptions.find((lang) => lang.value === i18n.language)}
              options={langOptions}
              onChange={handleChangeLanguage}
            />
          )}
          {profileTypeId && (
            <Button.ButtonOutlined className="bg-white" handler={() => setShowLogoutPopup(true)}>
              {getTranslation(t, 'logout.button', translationPrefix) || 'Logout'}
            </Button.ButtonOutlined>
          )}
        </div>
      </div>

      {/* Logout Confirmation Popup */}
      {showLogoutPopup && (
        <Popups.LogoutConfirmation
          onConfirm={handleLogoutConfirm}
          onClose={() => setShowLogoutPopup(false)}
          orgPrefix={translationPrefix}
          isLoading={isLoggingOut}
        />
      )}
    </div>
  );
}
